const postsToRefresh = new Set()
const refreshingPosts = new Set()

function postNumberFromUrl(url) {
  const pathname = new URL(url, globalThis.location.origin).pathname
  const match = pathname.match(/^\/posts\/([^/]+)$/)

  return match ? decodeURIComponent(match[1]) : null
}

document.addEventListener('turbo:before-visit', event => {
  const postNumber = postNumberFromUrl(event.detail.url)
  if (postNumber) postsToRefresh.add(postNumber)
})

document.addEventListener('turbo:load', () => {
  const openPostNumber = postNumberFromUrl(globalThis.location.href)

  postsToRefresh.forEach(postNumber => {
    if (postNumber === openPostNumber) return

    const post = document.querySelector(
      `[data-cache-refresh-post-number="${CSS.escape(postNumber)}"]`
    )
    if (!post) return

    refreshPost(postNumber)
  })
})

async function refreshPost(postNumber) {
  if (refreshingPosts.has(postNumber)) return
  refreshingPosts.add(postNumber)

  try {
    const response = await fetch(
      `/posts/${encodeURIComponent(postNumber)}/refresh_feed_card`,
      {
        headers: {
          Accept: 'text/vnd.turbo-stream.html',
          'X-Requested-With': 'XMLHttpRequest'
        },
        cache: 'no-store',
        credentials: 'same-origin'
      }
    )

    if (!response.ok) return

    const stream = await response.text()
    if (!stream.trim()) return

    Turbo.renderStreamMessage(stream)
    postsToRefresh.delete(postNumber)
  } catch (error) {
    console.error('Unable to refresh cached post:', error)
  } finally {
    refreshingPosts.delete(postNumber)
  }
}
